import React, { useState } from "react";
import { Form, Input, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { Items } from "../../services/items";
import { v4 as uuid } from "uuid";
import { useApiContext } from "../../hooks/useApiContext";

export default function InvoiceItemForm(props) {
  const { items,invoiceItemdispatch } = useApiContext();
  const [itemForm] = Form.useForm();
  const [price, setPrice] = useState();
  const [quantity, setQuantity] = useState();
  const [description, setDescription] = useState();
  const [amount, setAmount] = useState();
  const [withoutVat,setWithoutVat] = useState();

  const addInvoiceItem = () => {
    setWithoutVat(false)
    let newValues = {
      id: uuid(),
      description: description,
      price: Number(price),
      quantity: Number(quantity),
      amount: price * quantity,
      withoutVat: false
    };
    Items.add(invoiceItemdispatch, newValues);
    itemForm.resetFields();
  };

  const addInvoiceItemWithoutVat = () => {
    setWithoutVat(true)
    let newValues = {
      id: uuid(),
      description: description,
      price: Number(price),
      quantity: Number(quantity),
      amount: price * quantity,
      withoutVat: true
    };
    Items.add(invoiceItemdispatch, newValues);
    itemForm.resetFields();
  };

  return (
    <>
      <Form
        form={itemForm}
        layout="inline"
        name="horizontal_login"
        style={{ width: "100%" }}
      >
        <Form.Item
          name="description"
          rules={[
            {
              required: true,
              message: "Please enter Item description",
            },
          ]}
        >
          <Input
            placeholder="Item description"
            style={{ width: "90%" }}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Form.Item>
        <Form.Item
          name="price"
          rules={[
            {
              required: true,
              message: "Please enter Price",
            },
          ]}
        >
          <Input
            placeholder="Price"
            onChange={(e) => setPrice(e.target.value)}
            style={{ width: "90%" }}
          />
        </Form.Item>
        <Form.Item
          name="quantity"
          rules={[
            {
              required: true,
              message: "Please enter quantity",
            },
          ]}
        >
          <Input
            placeholder="Quantity"
            onChange={(e) => setQuantity(e.target.value)}
            style={{ width: "90%" }}
          />
        </Form.Item>
        <Form.Item name="amount" rules={[{ required: false }]}>
          <label name="amount" style={{ width: "90%" }}>
            {(price * quantity).toFixed(2)}
          </label>
        </Form.Item>
        <Form.Item shouldUpdate className="float-right">
          {() => (
            <Button
              disabled={items.length>0?items[0].withoutVat:false}
              type="primary"
              onClick={addInvoiceItem}
              icon={<PlusOutlined />}
            >
              Add
            </Button>
          )}
        </Form.Item>
        <Form.Item shouldUpdate className="float-right">
          {() => (
            <Button
            disabled={items.length>0?items[0].withoutVat==false: false }
              type="primary"
              onClick={addInvoiceItemWithoutVat}
              icon={<PlusOutlined />}
            >
              Add without Vat
            </Button>
          )}
        </Form.Item>
      </Form>
    </>
  );
}
